import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class BackDoors extends Component {
  render() {
    return (
      <EntityList apiRoute='api/backdoors' title='Remorque - Portes arrière' editTitle='Porte arrière' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Nombre de porte', Column: 'NumberDoor'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default BackDoors;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/backDoors.js
 **/